/**
 * reportFormat — pure number formatters + style const dùng chung cho Production
 * Report tabs (tách khỏi [[reportUi]] component-only để thoả react-refresh).
 * Format kế toán đã chốt ở tab BOM: số âm → ngoặc tròn; % đã ×100; USD prefix `$`.
 */
import { COLORS } from './styleTokens'

/** Format số: số âm → ngoặc tròn `(1,234.50)` (kế toán); null/NaN → '–'. */
export const fmtN = (n: number | null | undefined, d = 2): string => {
  if (n == null || !Number.isFinite(n)) return '–'
  const abs = Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d })
  return n < 0 ? `(${abs})` : abs
}

/** Format % (#,##0.00%). null/NaN → '–'. Số âm → ngoặc tròn kế toán `(1.23%)`.
 *  Tham số `n` đã ở đơn vị % (×100). */
export const fmtPct = (n: number | null | undefined, d = 2): string => {
  if (n == null || !Number.isFinite(n)) return '–'
  const abs = Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d })
  return n < 0 ? `(${abs}%)` : `${abs}%`
}

/** Format USD: `$1,234.50`; số âm → `($1,234.50)`; null/NaN → '–'. */
export const fmtUsd = (n: number | null | undefined, d = 2): string => {
  if (n == null || !Number.isFinite(n)) return '–'
  const abs = Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d })
  return n < 0 ? `($${abs})` : `$${abs}`
}

/** Label con (sentence case, in hoa chữ đầu) muted — dùng cho ExLabel / ExField
 *  ở mọi tab Batch Report (chị Đẹp 2026-06-18). Tên BLOCK (BlockTitle) + header
 *  section (sectionTitleSx) giữ uppercase riêng, KHÔNG dùng style này. */
export const fieldLabelSx = {
  fontSize: '0.66rem',
  color: COLORS.textMuted,
  fontWeight: 700,
  textTransform: 'none',
  letterSpacing: 0.6,
  whiteSpace: 'nowrap',
} as const
